export enum UserStatusType {
  ACTIVE,
  PENDING_VERIFICATION,
}
